import React from "react";
import { QuestionBox } from "../shared/QuestionBox";
import { Heading } from "../shared/Heading";
import { useContext } from "../../../../../context";
import { Options } from "../shared/Options";
import { BLOCK_FIELDS } from "../../../../../config";

export const MultipleChoice = () => {
  const { blocks, previewAnswers } = useContext();
  const block = blocks.getCurrent();

  const handleSelect = (value) => {
    const currentAnswers = previewAnswers.get(block.id) || [];
    if (currentAnswers.includes(value)) {
      previewAnswers.set(
        block.id,
        currentAnswers.filter((v) => v !== value),
      );
    } else {
      previewAnswers.set(block.id, [...currentAnswers, value]);
    }
  };

  return (
    <QuestionBox>
      <Heading
        title={block[BLOCK_FIELDS.question]}
        description={block[BLOCK_FIELDS.description]}
        index={blocks.getCurrentIndex() + 1}
      />
      <Options
        list={block[BLOCK_FIELDS.choices]}
        selected={previewAnswers.get(block.id) || []}
        onSelect={handleSelect}
      />
    </QuestionBox>
  );
};
